import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'

import { TextEdit, Timestamps } from '~/services'
import { Icon } from '~/components'
import { TextLoader } from '~/components/Loaders'


export default class extends React.Component {
    static propTypes = {
		activity: PropTypes.object.isRequired,
		fetching: PropTypes.bool,
		isSessionUser: PropTypes.bool
	};

    sort = (a, b) => {
		a = moment(a.date),
		b = moment(b.date);
	    if (b < a) return -1;
	    if (b > a) return 1;
	    return 0;
	};

    render() {

		let content = [];

		for (var a = 0; a < Object.keys(this.props.activity).length; a++) {

			let cat = Object.keys(this.props.activity)[a],
				posts = this.props.activity[cat];

			if( posts.length < 1 ) continue;

			let title = '';

			switch(cat) {
				case 'articles': 	title = 'Published'; break;
				case 'bookmarks': 	title = 'Bookmarked'; break;
				case 'comments': 	title = 'Commented with'; break;
				case 'flares': 		title = 'Flared'; break;
				case 'replies': 	title = 'Replied with'; break;
				case 'statements': 	title = 'Posted'; break;
			}

			for (var p = 0; p < posts.length; p++) {
				let post = posts[p]
				post.pre_title = title
				switch(cat) {
					case 'flares': 		post.date = post.flared; break;
					case 'bookmarks': 	post.date = post.bookmarked; break;
				}
				post.category = cat
				content.push(post)
			}

		}

		if( !this.props.sessionsAllowed ) {
			content = content.filter(post => post.post_type.singular_lower !== 'workshop');
		}

		content.sort(this.sort)

		return (
			<div className="panel stretch p20 mleft20 mleft0-xs mbot0">

				<h3 className="mtop0 mbot20">Recent Activity</h3>

                { this.props.fetching 
                	? <TextLoader />
                	: content.length > 0 
		                ? content.map(post => {
		                	let title = <span>{post.pre_title} "{ 
	                			post.link 
		                			? <Link to={post.link}>{ TextEdit.cutText(post.title, [45, 55]) }</Link> 
		                			: TextEdit.cutText(post.title, [45, 55])
	                		}"</span>
							return <p className="activity-row" key={'activity-list-'+post.category+'-'+post.ID}>
								<Icon icon={post.post_type.slug} className={'text-mid-danger mright10'} />
								{ title }
								<span className="hover-only text-dark-gray pleft10"><em>{Timestamps.shortDateTime(post.date)}</em></span>
							</p>

		                })
		                : ( !!this.props.isSessionUser
		                	? <p className="text-center mtop30">You don't have any recent activity yet. <Link to="/">Explore Five to Nine Club</Link></p>
		                	: <p className="text-center mtop30">No recent activity</p>
	                	)
	            }
	            
            </div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Profile/components/Body/components/Activity.jsx